import styled from 'styled-components';

import { borderRadius } from '~/design-tokens/border-radius/borderRadius';
import { breakpoints } from '~/design-tokens/breakpoints/breakpoints';
import {
  fontSize,
  typographyV2,
} from '~/design-tokens/typography/Typography.styles';

import { AlertType, AlertVariant } from './Alert';

export interface AlertStyledProps {
  type: AlertType;
  variant: AlertVariant;
  responsive?: boolean;
}

const BorderColor: Record<AlertType, string> = {
  error: 'var(--border-critical)',
  warning: 'var(--border-warning)',
  success: 'var(--border-success)',
  info: 'var(--border-default)',
};

const Bg: Record<AlertType, string> = {
  success: 'var(--surface-success)',
  warning: 'var(--surface-warning)',
  error: 'var(--surface-critical)',
  info: 'var(--surface-default)',
};

export const Alert = styled.div<AlertStyledProps>`
  display: flex;
  position: relative;
  ${borderRadius.r1};
  padding: ${props =>
    props.variant === 'inline' ? '16px 16px 16px 13px' : '16px'};
  color: var(--text-default);
  border: ${props =>
    props.variant === 'toast' && `1px solid ${BorderColor[props.type]}`};
  border-left: ${props =>
    props.variant === 'inline' && `4px solid ${BorderColor[props.type]}`};
  background-color: ${({ type }) => Bg[type]};
  width: 343px;
  max-width: 100%;

  @media ${breakpoints.xs} {
    width: 480px;
  }

  @media ${breakpoints.xlg} {
    width: 600px;
  }

  & svg {
    display: block;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  ${fontSize.f75}
`;

export const Title = styled.p`
  ${typographyV2.titleSm};
  flex-grow: 1;
`;

export const ContentSection = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Message = styled.div`
  ${typographyV2.bodySm};
`;

export const Close = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  margin-left: 12px;
  padding: 4px;

  svg {
    fill: var(--icon-soft);
  }

  &:hover svg {
    fill: var(--icon-default);
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  margin-top: 12px;

  > button:first-child {
    margin-right: 8px;
  }
`;
export const Icon = styled.div`
  margin-right: 8px;
`;
